import { render, staticRenderFns } from "./rpterstdconfirmbyco.vue?vue&type=template&id=e4640b6a&"
import script from "./rpterstdconfirmbyco.vue?vue&type=script&lang=js&"
export * from "./rpterstdconfirmbyco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports